import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["form", "screen", "detecting", "creating"]
  }

  static get values() {
    return { state: String }
  }

  connect() {
    if (document.startViewTransition) {
      addEventListener("turbo:before-frame-render", (event) => {
        const originalRender = event.detail.render

        event.detail.render = (currentElement, newElement) => {
          document.startViewTransition(() => {
            originalRender(currentElement, newElement)
          })
        }
      })
    }

    setTimeout(() => {
      this.screen()
    }, 2000)
  }

  detecting() {
    if (! this._submit()) {
      return
    }

    this._wrapInViewTransition(false, () => {
      this.screenTarget.classList.add("d-none")
      this.creatingTarget.classList.add("d-none")
      this.detectingTarget.classList.remove("d-none")
    })
  }

  creating() {
    if (! this._submit()) {
      return
    }

    this.screenTarget.classList.add("d-none")
    this.detectingTarget.classList.add("d-none")
    this.creatingTarget.classList.remove("d-none")
  }

  screen() {
    let ignoreTransition = !this.hasStateValue || this.stateValue === 'error'

    this._wrapInViewTransition(ignoreTransition, () => {
      this.screenTarget.classList.remove("d-none")
      this.detectingTarget.classList.add("d-none")
      this.creatingTarget.classList.add("d-none")

      if (this.hasStateValue) {
        this.element.classList.add(`smtp-imap-modal--${this.stateValue}`)
      }
    })

  }

  _submit() {
    if (! this.formTarget.checkValidity()) {
      return false
    }

    this.element.classList.remove("smtp-imap-modal--error")
    this.element.classList.remove("smtp-imap-modal--warning")
    this.element.classList.remove("smtp-imap-modal--success")
    this.formTarget.requestSubmit()

    return true
  }

  _wrapInViewTransition(ignore, callback) {
    if(document.startViewTransition && ignore === false) {
      document.startViewTransition(callback)
    } else {
      callback()
    }
  }
}
